import PreliminaryLifecarePlanRequest from '../../../../components/preliminary-lifecare/PreliminaryLifecarePlanRequest';

const PreliminaryLifecarePlanRequestPage = () => {
    return <PreliminaryLifecarePlanRequest />;
};

export default PreliminaryLifecarePlanRequestPage;
